import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListLastNameCell } from './emsp-bo-emsp-user-list-last-name.cell';
import { EmspBoEmspUserListLastNameHeader } from './emsp-bo-emsp-user-list-last-name.header';

export const EmspBoEmspUserListLastNameColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['lastName']
> = {
  enableSorting: true,
  header: EmspBoEmspUserListLastNameHeader,
  cell: EmspBoEmspUserListLastNameCell,
};
